import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetAllTags,
  DeleteTagById,
  AddTagApi,
  EditTagApi,
  GetTagById,
  GetAllParentTags,
} from "../../api";
import Select from "react-select";
import { Header, Button } from "../../components";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddProduct.css";
import { validateName } from "../../contexts/Utils";

const AddEditTag = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fromPage } = location.state || {};
  const { currentColor, userID, userToken } = useStateContext();
  const [tag, setTag] = useState("");
  const [gettags, setTags] = useState([]);
  const [tagOptions, settagOptions] = useState([]);
  const [tag_id, settag_id] = useState("");
  const [tagParent, setTagParent] = useState("");
  const [gettagParents, setTagParents] = useState([]);
  const [tagParentOptions, settagParentOptions] = useState([]);
  const [tagParent_id, settagParent_id] = useState("");
  const [name, setName] = useState("");
  const [ValError, setValError] = useState([]);
  const [mode, setMode] = useState("Add");

  const validName1 = (name, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (name.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (validateName(name)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handleAddMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Add");
      setTag("");
      settag_id("");
      setName("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Edit");
      setTag("");
      settag_id("");
      setName("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Delete");
      setTag("");
      settag_id("");
      setName("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddPTagClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate("/Product/AddEditParentTag");
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      navigate("/Product" + (fromPage === "AddProduct" ? "/" + fromPage : ""), {
        state: { fromPage: "Tag" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddSubmit = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();

    try {
      setValError([]);
      const updatedErrors = [...ValError];

      if (
        (mode === "Edit" || mode === "Delete") &&
        (!tag_id || tag_id === "")
      ) {
        updatedErrors[0] = "Select a Tag!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (name === "") {
        updatedErrors[1] = "Please enter name!";
        setValError(updatedErrors);
        return;
      }
      if (name) {
        if (validName1(name, 1) === false) {
          return;
        }
      }
      updatedErrors[1] = "";
      if (!tagParent_id || tagParent_id === "") {
        updatedErrors[2] = "Select a Parent Tag!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";
      setValError(updatedErrors);

      if (mode === "Add") {
        if (window.confirm("Do you want to add Tag?")) {
          AddTagApi(name, tagParent_id, userID, userToken)
            .then((res) => {
              if (res.status === 200) {
                navigate("/Product/AddEditTag", {
                  state: { fromPage: "Tag" },
                });
                alert("Added successfully.");
                window.location.reload();
              } else {
                alert("Fail to add Tag!");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      } else if (mode === "Edit") {
        if (window.confirm("Do you want to edit this Tag?")) {
          EditTagApi(tag_id, name, tagParent_id, userID, userToken)
            .then((res) => {
              if (res.status === 200) {
                navigate("/Product/AddEditTag", {
                  state: { fromPage: "Tag" },
                });
                alert("Updated successfully.");
                window.location.reload();
              } else {
                alert("Fail to edit Tag!");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      } else if (mode === "Delete") {
        if (window.confirm(`Do you want to remove ${tag.label} Tag?`)) {
          DeleteTagById(tag_id, userID, userToken)
            .then((res) => {
              if (res.status === 200) {
                navigate("/Product/AddEditTag", {
                  state: { fromPage: "Tag" },
                });
                alert("Removed successfully.");
                window.location.reload();
              } else {
                alert("Fail to remove Tag!");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChangeTag = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setTag(selectedOption);
        const selected_id = selectedOption.value;
        settag_id(selected_id);
        const resp1 = GetTagById(selected_id, userID, userToken);
        resp1
          .then(function (result) {
            setName(result.data[0].name);
            settagParent_id(result.data[0].parent_id || "");
            const tagP = tagParentOptions.find(
              (item) => item.value === result.data[0].parent_id || "",
            );
            setTagParent(tagP);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        setTag(selectedOption.label);
        settag_id("");
        setTagParent("");
        settagParent_id("");
      }
    } catch (err) {}
  };

  const handleChangeParentTag = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setTagParent(selectedOption);
        const selected_id = selectedOption.value;
        settagParent_id(selected_id);
      } else {
        setTagParent(selectedOption.label);
        settagParent_id("");
      }
    } catch (err) {}
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken) {
        GetAllTags(userID, userToken)
          .then((resp) => {
            setTags(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
        GetAllParentTags(userID, userToken)
          .then((resp) => {
            setTagParents(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [userID, userToken]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchStoreOptions = async () => {
      const fetchedStoreOptions = gettags.map((item) => ({
        label: `${item.name}`,
        value: item.tag_id,
      }));
      settagOptions(fetchedStoreOptions);
    };

    fetchStoreOptions();
  }, [gettags]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchStoreOptions = async () => {
      const fetchedStoreOptions = gettagParents.map((item) => ({
        label: `${item.name}`,
        value: item.tag_p_id,
      }));
      settagParentOptions(fetchedStoreOptions);
    };
    fetchStoreOptions();
  }, [gettagParents]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header
        title={
          mode === "Add"
            ? "ADD TAG"
            : mode === "Edit"
              ? "EDIT TAG"
              : "DELETE TAG"
        }
      />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{ padding: "0" }}
          >
            <Col md={2} className="container-col" />
            <Col md={4} className="container-col">
              {(mode === "Edit" || mode === "Delete") && (
                <>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="label">Tag List:</label>
                      <Select
                        className="myreact-select container-select"
                        value={tag}
                        onChange={handleChangeTag}
                        options={tagOptions}
                        isSearchable
                        placeholder="Select a Tag"
                      />
                      {ValError[0] && (
                        <p className="label-error-select">{ValError[0]}</p>
                      )}
                    </div>
                  </div>
                  <br />
                  <br />
                </>
              )}
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Name: </label>
                  <input
                    type="text"
                    className="input"
                    name="ct_name"
                    value={name}
                    onChange={handleChangeName}
                    placeholder="Tag Name"
                    onBlur={(e) => validName1(e.target.value, 1)}
                    disabled={mode === "Delete"}
                  />
                  {ValError[1] && <p className="label-error">{ValError[1]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">
                    Parent Tag:
                    <span style={{ float: "right", paddingRight: "22%" }}>
                      <button
                        style={{ fontSize: "13px" }}
                        onClick={handleAddPTagClick}
                      >
                        ➕
                      </button>
                    </span>
                  </label>
                  <Select
                    required
                    className="myreact-select container-select"
                    value={tagParent}
                    onChange={handleChangeParentTag}
                    options={tagParentOptions}
                    isSearchable
                    isDisabled={mode === "Delete"}
                    placeholder="Select a Parent Tag"
                  />
                  {ValError[2] && (
                    <p className="label-error-select">{ValError[2]}</p>
                  )}
                </div>
              </div>
              <br />
              <br />
            </Col>
            <Col md={4} className="container-col">
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Add"
                borderRadius="10px"
                onClick={handleAddMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Edit"
                borderRadius="10px"
                onClick={handleEditMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Delete"
                borderRadius="10px"
                onClick={handleDeleteMode}
              />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text={
            mode === "Add" ? "ADD NEW" : mode === "Edit" ? "UPDATE" : "REMOVE"
          }
          borderRadius="10px"
          className="custom-button ml-2"
          onClick={handleAddSubmit}
        />
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text="BACK"
          borderRadius="10px"
          className="custom-button ml-2"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditTag;
